import { render, staticRenderFns } from "./PartProgramGet&Send.vue?vue&type=template&id=70bc45ac&"
import script from "./PartProgramGet&Send.vue?vue&type=script&lang=js&"
export * from "./PartProgramGet&Send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports